import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Renderer2,
  Inject,
} from "@angular/core";
import { DOCUMENT } from "@angular/common";


import { MENU } from "./menu";
import { MenuItem } from "./menu.model";
import { Modules } from "../../../core/model/modules.enum";
import { Router, NavigationEnd } from "@angular/router";
import { AuthService } from "../../../providers/auth.service";
import { RoleFeatures } from "../../../core/model/user";
import { from, Observable, of } from "rxjs";
import { Privileges } from "../../../core/model/privileges.enum";
import { CustomerService } from "src/app/providers/customer.service";
import { CommonService } from "src/app/providers/common.service";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { UserType } from "../../../core/model/user-type.enum";
import  MetisMenu  from 'metismenujs';
import { get, isEmpty } from "lodash";
import { BillingPrivilege } from "src/app/core/model/merchantBiling";
import { SidebarService } from "./sidebar.service";
import { SubAppWindowBridgeService } from "src/app/core/services/sub-app-window-bridge.service";
import { envConfigService } from "src/app/providers/envconfig.service";
import { getDownloadLogRoute } from "src/app/core/utils/download-log-route";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit, AfterViewInit {
  @ViewChild("sidebarToggler") sidebarToggler: ElementRef;

  menuItems = [];
  @ViewChild("sidebarMenu") sidebarMenu: ElementRef;
  privileges = Privileges;
  customerPrivilege: any;
  sideBarLogoName: any;
  sideBarImage: any ;
  logo_Dashboard : any
  baseUrl = environment.apiUrl;
  imageUrl = environment.whitelabelLogoPath;
  isAllowChatBot = false;
  router: Router;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private authService: AuthService,
    router: Router,
    public customerService : CustomerService,
    private commonService : CommonService,
    private httpClient: HttpClient,
    private sidebarService: SidebarService,
    private subAppWindowBridge: SubAppWindowBridgeService,
    private configService: envConfigService
  ) {
    this.router = router;
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        /**
         * Activating the current active item dropdown
         */
        this._activateMenuDropdown();

        /**
         * closing the sidebar
         */
        if (window.matchMedia("(max-width: 991px)").matches) {
          this.document.body.classList.remove("sidebar-open");
        }
    
        this.hideToggleBar();
      }
    });
    
  }

  isSteamParamListDeviceLink(link: string | undefined | null): boolean {
    if (!link) return false;
    // Normalize trailing slash differences like "/steam-param/list-device/" vs "/steam-param/list-device"
    const normalized = link.trim().replace(/\/+$/, "");
    return normalized === "/steam-param/list-device";
  }

  ngOnInit(): void {
    
 
    this.menuItems = this.getMenuForCurrentUser(
      MENU,
      this.authService.getUser.roleFeatures
    );
    const { userType, userTypeRole } = this.authService?.getUserRoleType() || {};

    const isISOAdmin = userType === UserType.ISO && userTypeRole === UserType.ADMIN;
    const shouldRemoveBilling = !isISOAdmin || this.isPermission(BillingPrivilege.merchantBilling, BillingPrivilege.view);

    if (shouldRemoveBilling) {
      this.menuItems = JSON.parse(JSON.stringify((this.menuItems)));
      const invoicesMenu = this.menuItems.find(item => item.label === "Invoices");

      if (invoicesMenu?.subItems) {
        invoicesMenu.subItems = invoicesMenu.subItems.filter(subItem => subItem.label !== "Merchant Invoicing");
      }
    }

    // Filter menu groups by access
    this.menuItems = this.filterMenuGroupsByAccess(this.menuItems);
    
    this.applyDownloadLogMenuLink();

    

    const localWhitelabelData =JSON.parse(localStorage.getItem('whitelabelResData'));
    const customerLogo = this.authService?.getUser?.customerLogo;
    const whitelabelLogo = localWhitelabelData?.logo_dashboard;

    if (!isEmpty(whitelabelLogo)) {
      this.sideBarImage = `${this.imageUrl}/${whitelabelLogo}`;
    } else if (!isEmpty(customerLogo)) {
      this.sideBarImage = environment.apiFullUrl +'/assets/images/'+ customerLogo;
    } else {
      this.sideBarImage = environment?.defaultLogo;
    }
    /**
     * Sidebar-folded on desktop (min-width:992px and max-width: 1199px)
     */

    const desktopMedium = window.matchMedia(
      "(min-width:992px) and (max-width: 1199px)"
    );
    desktopMedium.addListener(this.iconSidebar);
    this.iconSidebar(desktopMedium);
  }

  ngAfterViewInit() {
    // activate menu item
    this.sidebarService.toggleSidebar$.subscribe(() => {
      console
      this.sidebarToggler.nativeElement.click();
    });
    new MetisMenu(this.sidebarMenu.nativeElement);
    this._activateMenuDropdown();    
    this.hideToggleBar();
    
    // Subscribe to router events to handle sidebar state restoration and active menu highlighting
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Small delay to ensure DOM is updated
        setTimeout(() => {
          this.hideToggleBar();
          this._activateMenuDropdown();
        }, 100);
      }
    });
  }

  customerToAgentOffice(item){
    //console.log(this.authService.getUser.userType);
    return this.authService?.getUser?.userType!=UserType.SYSTEM && item=='Customer'?UserType.AGENT_OFFICE:item;

  }

  /**
   * Toggle sidebar on hamburger button click
   */
  toggleSidebar(e) {
    const path = this.pathOnly(this.router.url);
    if (path === '/blink' || path === '/merchant-settings/settings/branding') {
      e.preventDefault();
      return;
    }
    
    // Save current sidebar state before toggling
    const isCurrentlyFolded = this.document.body.classList.contains("sidebar-folded");
    this.sidebarService.saveSidebarState(isCurrentlyFolded);
    
    this.sidebarToggler.nativeElement.classList.toggle("active");
    this.sidebarToggler.nativeElement.classList.toggle("not-active");
    if (window.matchMedia("(min-width: 992px)").matches) {
      e.preventDefault();
      this.document.body.classList.toggle("sidebar-folded");
    } else if (window.matchMedia("(max-width: 991px)").matches) {
      e.preventDefault();
      this.document.body.classList.toggle("sidebar-open");
    }
  }
  /** Path without query or hash (so /blink#ippBlinkHandoff=... still matches /blink). */
  private pathOnly(url: string): string {
    return (url || '').split('?')[0].split('#')[0];
  }

  hideToggleBar() {
    const path = this.pathOnly(this.router.url);
    if (!this.sidebarToggler || !this.sidebarToggler.nativeElement) {
      return;
    }
    if (path === '/blink' || path === '/merchant-settings/settings/branding') {
      this.document.body.classList.remove('open-sidebar-folded');
      this.document.body.classList.add('sidebar-folded');
      this.sidebarToggler.nativeElement.classList.remove('active');
      this.sidebarToggler.nativeElement.classList.add('not-active');
      this.sidebarService.clearSidebarState();
    } else {
      const previousState = this.sidebarService.getPreviousSidebarState();
      if (previousState === 'unfolded') {
        this.document.body.classList.remove('sidebar-folded');
        this.sidebarToggler.nativeElement.classList.remove('not-active');
        this.sidebarToggler.nativeElement.classList.add('active');
        this.sidebarService.clearSidebarState();
      } else if (previousState === 'folded') {
        this.document.body.classList.add('sidebar-folded');
        this.sidebarToggler.nativeElement.classList.remove('active');
        this.sidebarToggler.nativeElement.classList.add('not-active');
        this.sidebarService.clearSidebarState();
      } else {
        this.document.body.classList.remove('sidebar-folded');
        this.sidebarToggler.nativeElement.classList.remove('not-active');
        this.sidebarToggler.nativeElement.classList.add('active');
      }
    }
  }

  /**
   * Toggle settings-sidebar
   */
  toggleSettingsSidebar(e) {
    e.preventDefault();
    this.document.body.classList.toggle("settings-open");
  }

  /**
   * Open sidebar when hover (in folded folded state)
   */
  operSidebarFolded() {
    if (this.document.body.classList.contains("sidebar-folded")) {
      this.document.body.classList.add("open-sidebar-folded");
    }
  }

  /**
   * Fold sidebar after mouse leave (in folded state)
   */
  closeSidebarFolded() {
    if (this.document.body.classList.contains("sidebar-folded")) {
      this.document.body.classList.remove("open-sidebar-folded");
    }
  }

  /**
   * Sidebar-folded on desktop (min-width:992px and max-width: 1199px)
   */
  iconSidebar(e) {
    if (e.matches) {
      this.document && this.document.body.classList.add("sidebar-folded");
    } else {
      this.document && this.document.body.classList.remove("sidebar-folded");
    }
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  private applyDownloadLogMenuLink(): void {
    this.configService.loadConfig().then((envConfig) => {
      const route = getDownloadLogRoute(this.authService.getUserType(), envConfig);
      this.setDownloadLogsLink(this.menuItems, route);
    }).catch(() => {});
  }

  private setDownloadLogsLink(items: MenuItem[], route: string): void {
    (items || []).forEach((item) => {
      if (item.label === 'Download Logs' && item.privilege === Privileges.VIEW_DOWNLOAD_LOG) {
        item.link = route;
      }
      if (item.subItems) {
        this.setDownloadLogsLink(item.subItems, route);
      }
    });
  }

  /**
   * Reset the menus then hilight current active menu item
   */
  _activateMenuDropdown() {
    this.resetMenuItems();
    this.activateMenuItems();
  }

  /**
   * Resets the menus
   */
  resetMenuItems() {
    const links = document.getElementsByClassName("nav-link-ref");

    for (let i = 0; i < links.length; i++) {
      const menuItemEl = links[i];
      menuItemEl.classList.remove("mm-active");
      const parentEl = menuItemEl.parentElement;

      if (parentEl) {
        parentEl.classList.remove("mm-active");
        const parent2El = parentEl.parentElement;

        if (parent2El) {
          parent2El.classList.remove("mm-show");
        }

        const parent3El = parent2El.parentElement;
        if (parent3El) {
          parent3El.classList.remove("mm-active");

          if (parent3El.classList.contains("side-nav-item")) {
            const firstAnchor = parent3El.querySelector(".side-nav-link-a-ref");

            if (firstAnchor) {
              firstAnchor.classList.remove("mm-active");
            }
          }

          const parent4El = parent3El.parentElement;
          if (parent4El) {
            parent4El.classList.remove("mm-show");

            const parent5El = parent4El.parentElement;
            if (parent5El) {
              parent5El.classList.remove("mm-active");
            }
          }
        }
      }
    }
  }

  /**
   * Toggles the menu items
   */
  activateMenuItems() {
    const links = document.getElementsByClassName("nav-link-ref");

    let menuItemEl: any = null;
    const currentPath = this.pathOnly(this.router.url);

    for (let i = 0; i < links.length; i++) {
      const anchor = links[i] as HTMLAnchorElement;
      const linkPathname = anchor.pathname;
      const linkHref = anchor.getAttribute('href') || '';

      if ( linkPathname === currentPath || linkHref === currentPath || 
           (linkHref && currentPath && linkHref.endsWith(currentPath)) ) {
        menuItemEl = anchor;
        break;
      }

      if (currentPath.startsWith('/invoice') && (linkHref.endsWith('/virtual-terminal/invoice-list') || linkHref === '/virtual-terminal/invoice-list')) {
        menuItemEl = anchor;
        break;
      }
    }

    if (menuItemEl) {
      menuItemEl.classList.add("mm-active");
      const parentEl = menuItemEl.parentElement;

      if (parentEl) {
        parentEl.classList.add("mm-active");

        const parent2El = parentEl.parentElement;
        if (parent2El) {
          parent2El.classList.add("mm-show");
        }

        const parent3El = parent2El.parentElement;
        if (parent3El) {
          parent3El.classList.add("mm-active");

          if (parent3El.classList.contains("side-nav-item")) {
            const firstAnchor = parent3El.querySelector(".side-nav-link-a-ref");

            if (firstAnchor) {
              firstAnchor.classList.add("mm-active");
            }
          }

          const parent4El = parent3El.parentElement;
          if (parent4El) {
            parent4El.classList.add("mm-show");

            const parent5El = parent4El.parentElement;
            if (parent5El) {
              parent5El.classList.add("mm-active");
            }
          }
        }
      }
    }
  }

  getUserRole() {
    const role = this.authService.getUser.role;
    return role.trim().replace("_", " ").toLowerCase();
  }
  isPermission(modulename, privilege: any) {
    const moduleData = this.authService.getPrivileges(modulename);
    if (!moduleData || moduleData.features === undefined) return true;

    // External project modules (e.g. DEJA_UP) have no flat feature gate.
    // Access is granted only when at least one MODULE entry (with a `module` field)
    // has remaining features. Group entries (VENDING_INTERFACE, SETTINGS_INTERFACE)
    // are structural and do not count toward access on their own.
    if ((moduleData as any).isExternalProject) {
      const subModules = (moduleData as any).subModuleDetails;
      const hasAccessibleModule = Array.isArray(subModules) &&
        subModules.some((sm: any) => sm.module && Array.isArray(sm.features) && sm.features.length > 0);
      return !hasAccessibleModule;
    }

    this.customerPrivilege = moduleData.features;
    const required = Array.isArray(privilege) ? privilege : [privilege];
    return !required.some(priv => this.customerPrivilege.includes(priv));
  }

  // Filter menu groups by access
  private filterMenuGroupsByAccess(items: MenuItem[]): MenuItem[] {
    const ok = (n: MenuItem, root: string) =>
      n.subItems?.some((s) => ok(s, root)) ?? (!n.privilege || !this.isPermission(root, n.privilege));
    return (items || []).filter((i) => i?.isTitle || !i?.subItems?.length || ok(i, i.module));
  }
  getMenuForCurrentUser(
    defaultMenu: MenuItem[],
    allowedModules: RoleFeatures[]
  ) {
    let result = [];

    allowedModules.forEach((module) => {
      const allowedMenu = this.getAllowedMenu(defaultMenu, module);
      if (Array.isArray(allowedMenu) && allowedMenu.length > 0) {
        result.push(...allowedMenu);
      }
    });

    result.sort((a, b) => {
      if (a.indexId === undefined) return 1;
      if (b.indexId === undefined) return -1;
      return a.indexId - b.indexId;
    });



    const groupedMap = new Map<string, MenuItem>();

    result.forEach((menu) => {
      const groupKey = menu.moduleGroup || menu.module;
      let currentPrivileges: string[] = [];
      if (menu.privilege) {
        currentPrivileges = Array.isArray(menu.privilege)
          ? menu.privilege
          : [menu.privilege];
      }

      if (!groupedMap.has(groupKey)) {
        groupedMap.set(groupKey, {
          ...menu,
          privilege: [...currentPrivileges]
        });
      } else {
        const existing = groupedMap.get(groupKey);
        const existingPrivileges = Array.isArray(existing!.privilege)
          ? existing!.privilege
          : [existing!.privilege];

        const mergedPrivileges = Array.from(
          new Set([...existingPrivileges, ...currentPrivileges])
        );

        groupedMap.set(groupKey, {
          ...existing!,
          privilege: mergedPrivileges
        });
      }
    });

    const finalResult = Array.from(groupedMap.values());

    return finalResult;
  }


  getAllowedMenu(defaultMenu, Module) {
    const result = defaultMenu.filter(
      (menu) => menu.module === Module.module
    );
    return result;
  }

  atleastOneRoleAvailable(module: string) {
    const privilege = this.authService.getPrivileges(module);
    if (!privilege) {
      return true;
    }
    // External projects (e.g. DEJA_UP): API omits top-level `features`; gates live on subModuleDetails.
    if ((privilege as any).isExternalProject) {
      const subModules = (privilege as any).subModuleDetails;
      const hasAccessibleModule =
        Array.isArray(subModules) &&
        subModules.some(
          (sm: any) =>
            sm.module &&
            Array.isArray(sm.features) &&
            sm.features.length > 0
        );
      return !hasAccessibleModule;
    }
    const feature = get(privilege, "features", []);
    return isEmpty(feature);
  }

  checkMobileView(item): boolean {
    return this.commonService.isMobileView ? !!item.isMobileView : true;
  }

  /**
   * Before opening DejaUp, ask portal API to set the shared `accessToken` cookie again
   * (after DejaUp-only logout cleared it). Non-DejaUp external links ignore this handler.
   */
  onDejaupExternalLinkClick(e: MouseEvent, menuItem: MenuItem): void {
    if (menuItem.module !== Modules.DEJAUP || !menuItem.isExternalURL || !menuItem.link) {
      return;
    }
    e.preventDefault();
    const url = menuItem.link;
    const user = this.authService.getUser;
    const token = user?.accessToken;
    /** Same-origin `/portalApi/*` so Helmet `connect-src` allows it; proxy forwards to portal-backend `/v1`. */
    const base = (environment.apiUrl || "").replace(/\/$/, "");
    const syncUrl = `${base}/vms/sync-access-cookie`;
    const openDejaup = (): void => {
      const w = window.open(url, "_blank");
      this.subAppWindowBridge.registerDejaupWindow(w);
    };
    if (!token || !base) {
      openDejaup();
      return;
    }
    this.httpClient
      .post(syncUrl, {}, { headers: { xaccesstoken: token }, withCredentials: true })
      .subscribe({
        next: () => openDejaup(),
        error: () => openDejaup(),
      });
  }

}
